import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card card-xl-stretch mb-xl-8" }
const _hoisted_2 = { class: "card-body pt-10" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "mb-10 text-center" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-dark mb-3" }, "Thêm nhóm quyền")
], -1)
const _hoisted_4 = { class: "row fv-row mb-7" }
const _hoisted_5 = { class: "col-xl-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Nhóm Quyền", -1)
const _hoisted_7 = { class: "fv-plugins-message-container" }
const _hoisted_8 = { class: "fv-help-block" }
const _hoisted_9 = { class: "col-xl-9" }
const _hoisted_10 = { class: "fv-row" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bolder form-label mb-2" }, "Quyền hạn", -1)
const _hoisted_12 = { class: "table-responsive" }
const _hoisted_13 = { class: "table align-middle table-row-dashed fs-6 gy-5 table-roles" }
const _hoisted_14 = { class: "text-gray-600 fw-bold" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("td", { class: "text-gray-800 w-150px" }, "Quản trị", -1)
const _hoisted_16 = { class: "row" }
const _hoisted_17 = ["onUpdate:modelValue"]
const _hoisted_18 = { class: "form-check-label" }
const _hoisted_19 = { class: "text-center" }
const _hoisted_20 = {
  id: "kt_sign_up_submit",
  ref: "submitButton",
  type: "submit",
  class: "btn btn-lg btn-primary"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Lưu lại ", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Đang xử lý... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        class: "form w-100 fv-plugins-bootstrap5 fv-plugins-framework",
        novalidate: "novalidate",
        onSubmit: _ctx.onSubmit,
        id: "kt_login_signup_form",
        "validation-schema": _ctx.validateSchema
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_Field, {
                class: "form-control form-control-lg form-control-solid",
                type: "text",
                name: "name",
                autocomplete: "off"
              }),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_ErrorMessage, { name: "name" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("table", _hoisted_13, [
                    _createElementVNode("tbody", _hoisted_14, [
                      _createElementVNode("tr", null, [
                        _hoisted_15,
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_16, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listDataPermissionHTML, (item, index) => {
                              return (_openBlock(), _createElementBlock("label", {
                                key: index,
                                class: "form-check form-check-sm form-check-custom form-check-solid col-md-3 mb-1"
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "form-check-input",
                                  type: "checkbox",
                                  value: "1",
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.listDataPermissions[item._id]) = $event)
                                }, null, 8, _hoisted_17), [
                                  [_vModelCheckbox, _ctx.listDataPermissions[item._id]]
                                ]),
                                _createElementVNode("span", _hoisted_18, _toDisplayString(item.name), 1)
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("button", _hoisted_20, _hoisted_23, 512)
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ]))
}